import { render, staticRenderFns } from "./versionupdate.vue?vue&type=template&id=13ae9fce&"
import script from "./versionupdate.vue?vue&type=script&lang=js&"
export * from "./versionupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports